import StartFromTemplate from './StartFromTemplate.component';

export default StartFromTemplate;
